"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBooking = void 0;
class GetBooking {
    constructor(orderRepository) {
        this.orderRepository = orderRepository;
    }
    execute(request) {
        return this.orderRepository.getBooking(request);
    }
}
exports.GetBooking = GetBooking;
